import { Component, EventEmitter, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from '../data.service';
import { FilterDataService } from '../filter-data.service';
import { Router } from '@angular/router';
import { urls } from '../urls';


@Component({
  selector: 'app-sourcing-discovery',
  templateUrl: './sourcing-discovery.component.html',
  styleUrls: ['./sourcing-discovery.component.scss']
})
export class SourcingDiscoveryComponent {
  categoryList = []
  categoryResponse = {}
  defaultCategoryListLength = 10;
  searchInput: string
  selectedCategory: any; // Store the selected category
  selectedcategoryList = []
  @Output() firstPageFilter: EventEmitter<any> = new EventEmitter<any>();

  private destroy$: Subject<void> = new Subject<void>(); // Subject to handle subscription cleanup

  request: {};

  searchRequest = {};
  sbCatgeoty: string;
  sbCategory: any;

  selectedCategoryResponse: any;
  requestOpen = {}
  viewProductResponse: {};
  private subscription: Subscription;
  private viewProductResponseSubscription: Subscription;
  defaultCategorySelected: any;
  brandList:any;
  imgPrefix = urls.s3Link;

  constructor(private dataService: DataService, private filterDataService: FilterDataService, private router: Router) {


    this.defaultCategoryList();

  }

  ngOnInit(): void {
    localStorage.removeItem('page1slectedopenString');
    localStorage.removeItem('page1slectedCategory');
    this.fetchBrandList();

    // this.defaultCategoryList();

  }
  defaultCategoryList() {
    this.request = {
      "categoryCode": "2",
      "flag": false,
      "countryCode": this.dataService.getSelectedCountryCode(),
      "parentBusinessCode": this.dataService.getSelectedParentBusinessCode(),
      "defaultPage": true,
      "defaultCategory": null,
      "cisFlag":true
    };
    this.dataService.getCategoryL1List(this.request).subscribe(data => {

      if(data['statusCode']==="500" && data['categoryList']==null){
        this.router.navigateByUrl('no-data-found')
        this.dataService.showMessage('error', 'No Data Found');
        this.dataService.offSpinner()
      }
      else{

      this.dataService.showMessage('success', data['message']);
      this.categoryResponse = data

      this.defaultCategorySelected = this.categoryResponse['defaultChildCategoryDetails']['categoryCode']
      this.selectedCategory = this.categoryResponse['defaultChildCategoryDetails']['categoryCode']
      localStorage.setItem('page1slectedCategory', this.defaultCategorySelected);
      if (this.categoryResponse['statusCode'] === "200" && this.categoryResponse['categoryList'] != null) {
        this.categoryList = this.categoryResponse['categoryList'];
        if (this.categoryList && this.categoryList.length > 0) {


          this.searchRequest['searchQuery'] = this.categoryList[0]['categoryCode']
          this.searchRequest['countryCode'] = this.dataService.getSelectedCountryCode()

          this.searchCategoryData(this.searchRequest);
          this.request["categoryCode"] = this.defaultCategorySelected
          this.request["defaultPage"] = false;
          this.request["defaultCategory"] = this.defaultCategorySelected
          this.dataService.getCategoryL1List(this.request).subscribe(data => {

            this.selectedCategoryResponse = data
            this.selectedcategoryList = this.selectedCategoryResponse.defaultChildCategoryDetails.childCategories;
            this.dataService.offSpinner()
          });



        }
        this.dataService.offSpinner()

      }
      else {
        this.dataService.showMessage('error', data['error']);
        this.dataService.offSpinner()
      }
    }
    })
    this.dataService.eventTracker("CIS-PORTAL","Category-Listing",JSON.stringify(this.request),"/category-discovery");
  }


  getCategoryImage(category: any): string {
    if (category?.images?.mainImage?.links)
      return 'https://img.moglimg.com/' + category.images.mainImage.links.default;
    else
      return "https://catalog-dev.moglilabs.com/assets/img/NoImg.png"
  }
  getContentImage(subCategory: any): string {
    if (subCategory?.images?.mainImage?.links?.small)
      return 'https://img.moglimg.com/' + subCategory.images.mainImage.links.small;
    else
      return "https://catalog-dev.moglilabs.com/assets/img/NoImg.png"
  }
  selectCategory(category: any) {
    this.selectedCategory = category['categoryCode'];
    this.searchCategoryData(category);
  }

  searchCategoryData(category) {
    this.sbCategory = category.categoryName;
    this.selectedcategoryList = category.childCategories;

  }

  sidebarSelectedCategoryData(requestStr) {




    this.selectedcategoryList = []

    this.selectedCategoryResponse = this.selectedCategoryResponse
    this.sbCatgeoty = this.selectedCategoryResponse['defaultChildCategoryDetails']['categoryName']
    this.selectedcategoryList = this.selectedCategoryResponse['defaultChildCategoryDetails']['childCategories']


  }
  sidebarSelectedCategory(category) {
    this.selectedCategoryResponse = {}

    this.selectedCategory = category['categoryCode'];
    // Update the request object based on the selected category
    this.request["categoryCode"] = category.categoryCode;
    this.request["flag"] = false;
    this.request["defaultPage"] = false;
    this.request["defaultCategory"] = category.categoryCode;

    // Call the API to fetch the selected category data
    this.dataService.getCategoryL1List(this.request).subscribe(data => {

      this.selectedCategoryResponse = data
      this.selectedcategoryList = this.selectedCategoryResponse.defaultChildCategoryDetails.childCategories;
      this.dataService.offSpinner()
    });
  }

  oncontentSearchFilterChange(searchFilterChange: any) {

    const selectedCategoryCode = searchFilterChange['categoryCode'];
    const currentSelectedCategoryCode = localStorage.getItem('page1slectedCategory');

    localStorage.setItem('page1slectedCategory', selectedCategoryCode);
    const countryName = this.dataService.getSelectedCountryName().toLowerCase();
    this.requestOpen = {
      "productSearchString": "",
      "categoryCode": selectedCategoryCode,
      "brandIds": [],
      "viewEnabledFilter": false,
      "countryName": countryName
    };
    let pageNo = 0
    let pageSize = 20
    // const url = urls.search + `search/view/products?pageNo=${pageNo}&pageSize=${pageSize}`;

    // this.dataService.getProductViewAPI(url, this.requestOpen).pipe(takeUntil(this.destroy$)).subscribe(data => {

    //   if (data['status'] && data.data.products.length != 0) {
      //  this.dataService.emitSearchFilterChange(data);
      localStorage.setItem('status',"true")
        this.router.navigateByUrl('/product-discovery?category=' + selectedCategoryCode);
    //   } else {
    //     this.requestOpen = {};
    //     this.dataService.offSpinner()
    //     this.router.navigateByUrl('/no-result-found');

    //   }
    // });

  }


  onCategoryFilterChange(categoryName: string) {
  }


  onBrandFilterChange(brandFilterValue: any[]) {
  }


  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {
  }
  onSearchFilterChange(searchFilterChange: string) {
  }

  fetchBrandList(){
    let url = urls.platformdatprod+"cassandraFeed/utility/getBrandIdWithFlag?flag=true";

    this.dataService.callRestful('GET',url,null,null,null,null).subscribe(response=>{
      if(response.status && response.data){
        this.brandList=response.data;
        console.log(this.brandList)
        this.dataService.offSpinner();
      }else{
        this.dataService.offSpinner();
      }
    })
  }

  capitalizeFirstLetterOfEachWord(input: string): string {
    // Split the string into words
    const words = input.split(' ');

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the capitalized words back into a single string
    return capitalizedWords.join(' ');
  }

  navigateToBrandPage(brandId,brandName){
    this.dataService.setSelectedBrandId(brandId);
    this.dataService.setSelectedBrandName(brandName);
    window.open('/company-product-group?brand='+brandId+'&brandName='+brandName);
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
